module.exports = __webpack_public_path__ + "img/credit-one-club-gal-10.2ecab5ff.jpg";